export interface CountdownOptions {
  seconds: number;
  onTick: (remaining: number) => void;
  signal?: AbortSignal;
}

/** Counts down from `seconds` to 0, emitting one tick per second. */
export async function runCountdown(opts: CountdownOptions): Promise<void> {
  const { seconds, onTick, signal } = opts;
  for (let i = seconds; i > 0; i--) {
    if (signal?.aborted) throw new DOMException('aborted', 'AbortError');
    onTick(i);
    await sleep(1000, signal);
  }
  onTick(0);
}

function sleep(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException('aborted', 'AbortError'));
      return;
    }
    const t = setTimeout(() => {
      if (signal) signal.removeEventListener('abort', onAbort);
      resolve();
    }, ms);
    const onAbort = () => {
      clearTimeout(t);
      reject(new DOMException('aborted', 'AbortError'));
    };
    if (signal) signal.addEventListener('abort', onAbort, { once: true });
  });
}
